import React, { FC, useEffect, useState } from "react";
import { Element } from "../../../models/elementModel";
import "react-tippy/dist/tippy.css";
import { Tooltip } from "react-tippy";
import { useDispatch, useSelector } from "react-redux";
import { startApplyRule } from "../../../actions/ruleAction";
import { getSession } from "../../../selectors/appSelectors";
import './Remarks.scss';

export interface RenderImgProps {
  index: string;
  element: Element;
  isPreview?: boolean;
}

const ImageElement: FC<RenderImgProps> = ({ index, element, isPreview = false }) => {
  const dispatch = useDispatch();
  const sessionState = useSelector(getSession);
  const [viewRemark, setViewRemark] = useState(sessionState.viewRemark);
  const [onClickActions, setOnClickActions] = useState(
    element.actions.filter((action) => {
      return action.actionType === "onClick";
    })
  );
  const [open, setIsOpen] = useState(false);


  useEffect(() => {
    setViewRemark(sessionState.viewRemark)
    console.log(sessionState.viewRemark)

  }, [sessionState])

  async function OnClickActions() {
    await Promise.all(
      onClickActions.map(async (action) => {
        dispatch(startApplyRule(action));
      })
    );
  }

  const defaultStyle = {
    marginTop: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginTop + "px",
    marginRight: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginRight + "px",
    marginBottom: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginBottom + "px",
    marginLeft: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginLeft + "px",
    textAlign: element.styles.textAlign,
  };

  //custome css - start
  const styleList = element.properties.cssStyles;

  const styleObj: { [key: string]: any } = {};

  for (let index = 0; index < styleList.length; index++) {
    styleObj[styleList[index].retrivedStyle] = styleList[index].value;
  }
  //custome css - end
  return (
    <div key={index} style={{ ...defaultStyle }}>
      <Tooltip title={element.properties.tooltip}>
        {!isPreview && (
          <img
            src={element.properties.imageUrl}
            className={`img-fluid ${
              element.properties.display === false ? "blur-element" : ""
            }`}
            alt={element.properties.alt}
            style={{
              cursor: element.properties.cursor,
              height:
                element.styles.height === "" ||
                element.styles.height === undefined ||
                element.styles.height === "0"
                  ? ""
                  : element.styles.height + "px",
              width:
                element.styles.width === "" ||
                element.styles.width === undefined ||
                element.styles.width === "0"
                  ? ""
                  : element.styles.width + "px",
              ...styleObj,
            }}
          />
        )}
        {isPreview && (
          <img
            src={element.properties.imageUrl}
            className={`img-fluid`}
            alt={element.properties.alt}
            style={{
              cursor: element.properties.coursorType,
              height:
                element.styles.height === "" ||
                element.styles.height === undefined ||
                element.styles.height === "0"
                  ? ""
                  : element.styles.height + "px",
              width:
                element.styles.width === "" ||
                element.styles.width === undefined ||
                element.styles.width === "0"
                  ? ""
                  : element.styles.width + "px",
              ...styleObj,
            }}
            onClick={OnClickActions}
          />
        )}
      </Tooltip>
      {isPreview &&
        viewRemark &&
        (element.properties.remark1 ||
          element.properties.remark2 ||
          element.properties.remark3 ||
          element.properties.remark4) && (
          <Tooltip
            interactive
            open={open}
            onRequestClose={() => setIsOpen(false)}
            html={
              <>
                <h6>Remarks of {element.name}</h6>
                {element.properties.remark1 !== undefined &&
                  element.properties.remark1 !== "" && (
                    <div className="remark">
                      Remark 1 : {element.properties.remark1}
                    </div>
                  )}
                {element.properties.remark2 !== undefined &&
                  element.properties.remark2 !== "" && (
                    <div className="remark">
                      Remark 2 : {element.properties.remark2}
                    </div>
                  )}
                {element.properties.remark3 !== undefined &&
                  element.properties.remark3 !== "" && (
                    <div className="remark">
                      Remark 3 : {element.properties.remark3}
                    </div>
                  )}
                {element.properties.remark4 !== undefined &&
                  element.properties.remark4 !== "" && (
                    <div className="remark">
                      Remark 4 : {element.properties.remark4}
                    </div>
                  )}
                {(element.properties.remark1 === undefined ||
                  element.properties.remark1 === "") &&
                  (element.properties.remark2 === undefined ||
                    element.properties.remark2 === "") &&
                  (element.properties.remark3 === undefined ||
                    element.properties.remark3 === "") &&
                  (element.properties.remark4 === undefined ||
                    element.properties.remark4 === "") && (
                    <div>No Remarks to Display</div>
                  )}
              </>
            }
            position="left"
          >
            <div style={{ textAlign: "end" }}>
              <i
                className="fa fa-info-circle"
                aria-hidden="true"
                onClick={() => {
                  setIsOpen(true);
                }}
              ></i>
            </div>
          </Tooltip>
        )}
    </div>
  );
};

export default ImageElement;
